class PaymentsForm
  constructor: ->
    $(document).ready =>
      this.updateSender()
      this.updateReceiver()
      $('form.new_payment, form.edit_payment').find('input#payment_private_sender').change (changedEvent) =>
        this.updateSender()
      $('form.new_payment, form.edit_payment').find('input#payment_private_receiver').change (changedEvent) =>
        this.updateReceiver()

  updateSender: ->
    if $('input#payment_private_sender').is(':checked')
      $('select#payment_sender_id').prop('disabled', true);
    else
      $('select#payment_sender_id').prop('disabled', false);

  updateReceiver: ->
    if $('input#payment_private_receiver').is(':checked')
      $('select#payment_receiver_id').prop('disabled', true);
    else
      $('select#payment_receiver_id').prop('disabled', false);

window.addEventListener('turbolinks:load', () => new PaymentsForm())
